import request from '../utils/axios/request';
import { PaginationContent } from '../utils/types/pagination';
import { Query } from '../utils/types/query';
import { IHarbor } from './Harbor.service';

interface QueryYard extends Query {
	idHarbor?: number;
	idClient?: number;
}

export interface IYard {
	id?: number;
	name: string;
	isActive: boolean;
	sockets?: string;
	harbor?: Partial<IHarbor>;
	actions?: any;
}

abstract class YardService {
	static async getAll(
		params?: QueryYard
	): Promise<PaginationContent<IYard> | undefined> {
		let isActive;
		if (params?.isActive && Number(params.isActive) > -1) {
			isActive = params.isActive;
		}

		try {
			const response: PaginationContent<IYard> = await request(
				'/yards',
				'get',
				{
					params: { ...params, isActive },
				}
			);
			return response;
		} catch (error: any) {}
	}

	static async create(
		data: IYard,
		setError: React.Dispatch<React.SetStateAction<string>>
	) {
		return this.createOrEdit(data, setError, 'post');
	}

	static async edit(
		data: IYard,
		setError: React.Dispatch<React.SetStateAction<string>>
	) {
		return this.createOrEdit(data, setError, 'patch');
	}

	private static async createOrEdit(
		content: IYard,
		setError: React.Dispatch<React.SetStateAction<string>>,
		mode: 'post' | 'patch'
	) {
		try {
			const { id, harbor, sockets, ...data } = content;
			const url = mode === 'post' ? '/yards' : `/yards/${id}`;
			const response = await request(url, mode, {
				data: {
					...data,
					idHarbor: harbor?.id,
					sockets: sockets === '' ? undefined : Number(sockets),
				},
			});
			return response;
		} catch (error) {
			setError('alert.error.generic');
		}
	}

	static async delete(id: number) {
		try {
			const response = await request(`/yards/${id}`, 'delete');
			return response;
		} catch (error) {
			console.log(error);
		}
	}
}

export default YardService;
